import $ from 'jquery';

$('.js-form-auto-submit').each(function () {
    const self = this, $self = $(self);

    $self.find('input, select, textarea').each(function () {
        $(this).on('change', () => {
            $self.submit();
        });
    });
});
